import { render } from "./CategoryDetails.vue?vue&type=template&id=ade600b8&scoped=true"
import script from "./CategoryDetails.vue?vue&type=script&lang=js"
export * from "./CategoryDetails.vue?vue&type=script&lang=js"

import "./CategoryDetails.vue?vue&type=style&index=0&id=ade600b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade600b8"]])

export default __exports__